import React, { useState, useEffect } from "react";
import Button from "../../atoms/Button";
import DiaglogBox from "../../atoms/DiaglogBox";
import CustomCheckBox from "../../atoms/CustomCheckBox";
import { deleteBids } from "../../../utils/API/deleteBid";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { LoadingOutlined } from "@ant-design/icons";

const CancelListPopup = ({ open, onCancel, onOk, selectedRowData, projId }) => {
  const dispatch = useDispatch();
  const [isChecked, setChecked] = useState(false);
  const [agreeTermsError, setAgreeTermsError] = useState("");
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState("");
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState("");
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleCancelCheck = () => {
    setChecked(!isChecked);
  };

  const handleReson = (e) => {
    setReason(e.target.value);
  };

  const handleRemarks = (e) => {
    setRemarks(e.target.value);
  };

  useEffect(() => {
    if (selectedRowData && selectedRowData["Project Id"]) {
      const projectId = selectedRowData["Project Id"];
      setFormData((prevFormData) => ({
        ...prevFormData,
        projectId: projectId,
        reason: reason,
        Remarks: remarks,
      }));
    } else {
      console.error("selectedRowData or Project Id is undefined");
    }
  }, [selectedRowData, reason, remarks]);

  const handleDeleteBids = async () => {
    if (reason === "" || remarks === "" || !isChecked) {
      if (reason === "") {
        setReasonError("Please give a reason before cancelling this bid");
      }
      if (remarks === "") {
        setRemarksError("Please give remarks before cancelling this bid");
      }
      if (!isChecked) {
        setAgreeTermsError("Please confirm before submit");
      }
    } else {
      try {
        setLoading(true);
        await deleteBids(formData, dispatch);
        setReasonError("");
        setReason("");
        setRemarksError("");
        setRemarks("");
        setAgreeTermsError("");
        onOk();
      } catch (error) {
        toast.error(error);
      }
      finally{
        setLoading(false)
      }
    }
  };

  const handleCancel = () => {
    if (isChecked) {
      setChecked(false);
    }
    setReasonError("");
    setReason("");
    setRemarksError("");
    setRemarks("");
    setAgreeTermsError("");
    onCancel();
  };

  return (
    <DiaglogBox open={open} onCancel={handleCancel} width={617}>
      <div className="flex justify-center h-full pt-5">
        <div className="font-bold text-28 text-3xl">Unlist bid</div>
      </div>
      <div>
        <hr className=" ml-8 w-[544px] border-t-2 text-zinc-500  my-4" />
        <div className="ml-8 text-base font-normal">
          <CustomCheckBox
            isChecked={isChecked}
            labelText="Are you sure you want Unlist"
            onChange={() => handleCancelCheck()}
          />
        </div>
        <p className="text-red-500 text-xs mx-10">{agreeTermsError}</p>

        <hr className="ml-8  w-[544px] border-t-2 text-zinc-500 my-2" />
        <p className="ml-8 ">Reason</p>
        <div className="pt-2">
          <select
            className="ml-9 pl-3.5 w-[542px] h-[28px] text-sm font-normal leading-normal border text-zinc-500 rounded-lg"
            value={reason}
            onChange={handleReson}
          >
            <option value="" disabled >
              Select the Reason
            </option>
            <option value="no_longer_available">The project is No Longer Available</option>
            <option value="project_blacklisted">The Project is backlisted by the Registry</option>
            <option value="not_getting_required_price">I am not getting the required price</option>
            <option value="waiting_for_credits">I am Waiting for more issuance of Credits</option>
            <option value="will_sell">Will sell </option>
            <option value="time_consuming">Offsetgo Marketplace Portal is too time-consuming (If customers choose this then remarks are mandated) </option>
            <option value="tiresome_process">Tiresome Process</option>
            <option value="others">Others</option>
          </select>
        </div>
        <p className="mx-10 text-red-500 text-xs mt-2">{reasonError}</p>
        <hr className="ml-8 w-[544px] border-t-2 text-zinc-500 my-3" />
        <div className="pl-9">
          <input
            type="text"
            className="w-[542px] h-[71px] border text-gray-700  rounded-md pl-4 "
            placeholder="Remarks"
            value={remarks}
            onChange={handleRemarks}
          />
        </div>
        <p className="mx-10 text-red-500 text-xs mt-2">{remarksError}</p>
        <div className="pl-44 pt-3.5 pb-5">
          <Button
            varient="primary"
            color="blue"
            onClick={handleDeleteBids}
            disabled={loading}
            className="w-64 h-14 text-base  text-white font-bold border-[1px] "
          >
               {loading ? <LoadingOutlined /> : "Submit"}
          </Button>
        </div>
      </div>
    </DiaglogBox>
  );
};

export default CancelListPopup;
